import ParsingAds from './ParsingAds'
import WithParsing from 'containers/WithParsing'

export default WithParsing(ParsingAds)
